/* eslint-disable @typescript-eslint/quotes */
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ServerService} from '../service/server.service';
import {
  AlertController,
  LoadingController,
  ModalController,
  NavController,
  Platform,
  ToastController
} from '@ionic/angular';
import {AuthService} from "../service/auth.service";
import {GooglePlus} from "@ionic-native/google-plus/ngx";
import {environment} from "../../environments/environment";
import {getAuth, GoogleAuthProvider, signInWithPopup} from "firebase/auth";
import {initializeApp} from "firebase/app";
import {DocumentModalPage} from "./document-modal/document-modal.page";
import {StatusBar} from "@awesome-cordova-plugins/status-bar/ngx";
import {Constant} from "../shared/model/Constant";
import {ForgotPage} from "../forgot/forgot.page";


@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})

export class LoginPage implements OnInit {

  email: any;
  password: any;
  twoFa: any;
  isWeb: boolean;
  showPassword = false;
  googleUser: any;

  constructor(public alertController: AlertController,
              private route: ActivatedRoute,
              public server: ServerService,
              public toastController: ToastController,
              private nav: NavController,
              public loadingController: LoadingController,
              private authService: AuthService,
              private platform: Platform,
              private googlePlus: GooglePlus,
              private modalController: ModalController,
              private statusBar: StatusBar) {
    initializeApp(environment.firebaseConfig);
    this.isWeb = this.platform.width() >= 900;
  }

  ngOnInit() {
  }


  async login(data) {
    if (data.document.length == 0 || data.password.length == 0) {
      return this.presentToast("Por favor, introduzca datos de inicio de sesión válidos");
    }

    const loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 30000
    });
    await loading.present();
    this.authService.login(data).subscribe((res: any) => {
      localStorage.setItem(Constant.userId, res.document);
      localStorage.setItem(Constant.token, res.token);
      if (!res.using2FA && res.qrMfa !== 'used') {
        this.twoFa = res;
      } else {
        console.log('se va por el else')
        window.location.href = '/login/otp';
      }
      loading.dismiss();
    }, error => {
      console.warn('Error login', error);
      this.presentToast('Por favor, introduzca datos de inicio de sesión válidos');
      loading.dismiss();
    });
  }

  async presentToast(txt) {
    const toast = await this.toastController.create({
      message: txt,
      duration: 3000,
      position: 'top',
      mode: 'ios',
      color: 'dark'
    });
    toast.present();
  }


  otpResult(event: any) {
    if (event === 'true') {
      window.location.href = '/main';
    }
  }

  googleSignIn() {
    const auth = getAuth();
    const provider = new GoogleAuthProvider();

    signInWithPopup(auth, provider).then((result) => {
      const googleUser = result.user;
      this.authService.findByGoogle(googleUser.uid).subscribe((value: any[]) => {
        if (!value || value.length === 0) {
          this.showDocumentModal().then((document) => {
            const {name, lastName} = this.displayNameToNameAndLastName(googleUser.displayName);
            if (document) {
              const data = {
                googleId: googleUser.uid,
                email: googleUser.email,
                password: document,
                document, name, lastName
              };
              console.log(data);
              this.authService.createUser(data).subscribe(res => {
                console.log(res);
              });
            }
          });
        } else {
          const user = value[0];
          localStorage.setItem(Constant.userId, '4');
          if (!user.using2FA) {
            user.document = user.userId;
            this.twoFa = user;
          } else {
            window.location.href = '/main';
          }
        }
      });
    }).catch((error) => {
      console.error(error);
    });
  }

  async showDocumentModal(): Promise<string | null> {
    const modal = await this.modalController.create({
      component: DocumentModalPage,
      animated: true,
      mode: 'ios',
      cssClass: 'my-custom-modal-css',
      backdropDismiss: true,
      swipeToClose: true
    });
    await modal.present();
    return modal.onDidDismiss().then((data: any) => {
      if (data && data.data && data.data.document) {
        return data.data.document;
      }
    });
  }

  displayNameToNameAndLastName(displayName) {
    const parts = displayName.split(' ');
    const name = parts[0];
    let lastName = '';
    if (parts.length > 1) {
      lastName = parts.slice(1).join(' ');
    }
    return {name, lastName};
  }


  validateOnlyNumbers() {
    if (!this.email) {
      return '';
    }
    this.email = String(this.email).replace(/\D/g, '');
  }

  async forgotPage(data?: any) {
    const modal = await this.modalController.create({
      component: ForgotPage,
      animated: true,
      mode: 'ios',
      cssClass: 'my-custom-modal-css',
      backdropDismiss: true,
      swipeToClose: true,
      componentProps: {
        'data': data,
      }
    });
    return await modal.present();
  }
}
